import { Link } from 'react-router-dom';

import guillemetsIn from '../assets/guillemets-in.png';
import guillemetsOut from '../assets/guillemets-out.png';
import cpuComplique from '../assets/cpu-complique.webp';

export default function Simplicite() {
  return (
    <>
      <section className="section">
        <div className="container text-center" data-aos="fade-up">
          <span className="eyebrow">Notre engagement</span>
          <h1 className="fw-900 mt-3 display-5">Simplicité</h1>
        </div>
      </section>

      {/* CITATION */}
      <section className="section pt-0">
        <div className="container">
          <div className="quote-block p-4 p-md-5" data-aos="zoom-in">
            <div className="row align-items-center g-3">
              <div className="col-auto d-none d-md-block">
                <img src={guillemetsIn} alt="" className="quote-mark rounded-3" />
              </div>
              <div className="col">
                <p className="fs-3 fw-bold text-center text-md-start mb-0" style={{ color: '#fff' }}>
                  Chez CPUc Solutions Technologiques, nous transformons les défis
                  informatiques en solutions simples et efficaces.
                </p>
              </div>
              <div className="col-auto d-none d-md-block">
                <img src={guillemetsOut} alt="" className="quote-mark rounded-3" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SIMPLICITÉ + IA */}
      <section className="section pt-0">
        <div className="container">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eyebrow">Comment</span>
              <h2 className="fw-900 mt-3">
                Une approche humaine, soutenue par l'intelligence artificielle
              </h2>
              <p className="text-secondary mt-3">
                Derrière chaque demande, une personne de notre équipe répond — sans jargon,
                avec des explications claires. L'intelligence artificielle vient appuyer ce
                travail : surveillance proactive de vos systèmes, détection rapide des
                anomalies et automatisation des tâches répétitives, pour que nos techniciens
                se concentrent sur ce qui compte vraiment : vous.
              </p>
              <Link to="/support" className="fw-bold text-decoration-none">
                Découvrir notre support technique <i className="bi bi-arrow-right ms-1"></i>
              </Link>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="section-img">
                <img src={cpuComplique} alt="Illustration d'un assistant technologique au service des entreprises" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
